import { api } from '@/lib/api';

export interface OnboardingStep {
  key: string;
  label: string;
  phase: 1 | 2 | 3;
  dependsOn: string[];
  milestone: boolean;
  completed: boolean;
  completedAt: string | null;
  skipped: boolean;
  skippedAt: string | null;
}

export interface OnboardingStatus {
  currentStep: number;
  steps: OnboardingStep[];
  isComplete: boolean;
  completedAt: string | null;
}

export async function getOnboardingProgress(): Promise<OnboardingStatus> {
  const { data } = await api.get<OnboardingStatus>('/onboarding/progress');
  return data;
}

export async function completeStep(stepKey: string): Promise<OnboardingStatus> {
  const { data } = await api.patch<OnboardingStatus>(`/onboarding/step/${stepKey}`);
  return data;
}

export async function skipStep(stepKey: string): Promise<OnboardingStatus> {
  const { data } = await api.post<OnboardingStatus>(`/onboarding/skip/${stepKey}`);
  return data;
}

export async function goToStep(step: number): Promise<OnboardingStatus> {
  const { data } = await api.post<OnboardingStatus>('/onboarding/go-to', { step });
  return data;
}

export async function completeOnboarding(): Promise<{ message: string }> {
  const { data } = await api.post<{ message: string }>('/onboarding/complete');
  return data;
}

export async function resetOnboarding(): Promise<OnboardingStatus> {
  const { data } = await api.post<OnboardingStatus>('/onboarding/reset');
  return data;
}
